import React, { useCallback, useEffect, useState } from "react";
import { api, exportCsv, monthStartStr, todayStr } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { DataTable } from "@/components/common/DataTable";
import { FormField } from "@/components/stock/FormField";
import { Download } from "lucide-react";

const ACTION_CLS = { Tambah: "bg-emerald-100 text-emerald-800", Edit: "bg-sky-100 text-sky-800", Hapus: "bg-red-100 text-red-800" };

export default function AuditLog() {
  const { t } = useLang();
  const [range, setRange] = useState({ start: monthStartStr(), end: todayStr() });
  const [rows, setRows] = useState([]);
  const load = useCallback(() => { api.get("/audit-logs", { params: range }).then((r) => setRows(r.data)); }, [range]);
  useEffect(() => { load(); }, [load]);

  const columns = [
    { key: "at", label: t("audit_time"), className: "font-mono text-xs whitespace-nowrap" },
    { key: "email", label: t("user"), className: "text-xs whitespace-nowrap" },
    { key: "role", label: t("role"), className: "text-xs uppercase" },
    { key: "action", label: t("audit_action"), render: (r) => (
      <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${ACTION_CLS[r.action] || "bg-amber-100 text-amber-800"}`}>{r.action}</span>
    ) },
    { key: "module", label: t("audit_module"), className: "text-xs whitespace-nowrap" },
    { key: "target", label: t("audit_target"), className: "font-mono text-xs" },
    { key: "detail", label: t("note"), className: "text-xs text-slate-600" },
  ];

  return (
    <div className="space-y-6" data-testid="audit-log-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>{t("audit_log")}</h1>
        <p className="text-sm text-slate-500 mt-1">{t("audit_subtitle")}</p>
      </div>
      <Card className="border-slate-200">
        <CardContent className="p-0">
          <div className="p-4 border-b border-slate-200 flex flex-wrap items-end gap-3">
            <FormField label={t("start_date")}><Input type="date" value={range.start} onChange={(e) => setRange({ ...range, start: e.target.value })} data-testid="audit-start-input" /></FormField>
            <FormField label={t("end_date")}><Input type="date" value={range.end} onChange={(e) => setRange({ ...range, end: e.target.value })} data-testid="audit-end-input" /></FormField>
            <Button size="sm" variant="outline" className="ml-auto" onClick={() => exportCsv("audit-logs", range)} data-testid="audit-export-btn">
              <Download size={14} className="mr-2" />{t("export_excel")}
            </Button>
          </div>
          <DataTable columns={columns} rows={rows} testid="audit-log-table" />
        </CardContent>
      </Card>
    </div>
  );
}
